<!-- 销售订单历史 -->
<template>
    <div class='page_content'>
       <processAuditAction ref="processAuditAction"></processAuditAction>
       <!-- <subComponents  ref="showSelectData"></subComponents> -->
       <div class="page_content_top">
          <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
          <div class="page_content_top_line">
             <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
             </v-search>
          </div>
       </div>
       <div class="page_content_center">
          <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
             <el-table-column label="选择操作" width="80">
                <template slot-scope="scope">
                   <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                      <i class="el-icon-thumb"></i>
                   </el-radio>
                </template>
             </el-table-column>
             <el-table-column v-if="tableValye.isShow == 1" align="center" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
                              :prop="tableValye.entityField" :label="tableValye.showField">
                <template slot-scope="scope">
                   <!-- <span v-if="tableValye.fieldType == 'date'">
               <span v-if="scope.row[tableValye.entityField]">
                 {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
               </span>
             </span> -->
                   <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                      {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                   </span>
                   <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                      {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                   </span>
                   <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                      {{ scope.row.isWms == 0 ? '否' : '是' }}
                   </el-tag>
                   <span v-else-if="tableValye.isRift == 1">
                      <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                         scope.row[tableValye.entityField] }}</a>
                   </span>
                   <el-tag size="mini" v-else-if="tableValye.entityField == 'woamState'">{{
                                     $common.getIsGsp(tableValye.formatterContent, scope.row.woamState) }}</el-tag>
                   <span v-else-if="tableValye.fieldType == 'formatter'">{{
                                     $common.getIsGsp(tableValye.formatterContent,
                                         scope.row[tableValye.entityField]) }}</span>
                   <span v-else>
                      {{ scope.row[tableValye.entityField] }}
                   </span>
                </template>
             </el-table-column>
          </el-table>
       </div>
       <div class="page_content_bottom">
          <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
       </div>
       <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
          <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" :smId="cmId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
       </el-dialog>
       <el-drawer id="drawerBox" :close-on-press-escape="true" :visible.sync="showAfterSales" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
          <salesOrderHistoryMXInfo v-if="showAfterSales" ref="salesOrderHistoryMXInfo" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData">
          </salesOrderHistoryMXInfo>
       </el-drawer>
       <!-- 自定义设计 -->
       <customDesign ref="customDesign"></customDesign>
    </div>
 </template>
 
 <script>
 //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
 //例如：import 《组件名称》 from '《组件路径》';
 import SearchScheme from "../../../byComponents/SearchScheme.vue";
 import salesOrderHistoryMXInfo from '@/components/salesOrderHistoryMXInfo.vue'
 export default {
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme,salesOrderHistoryMXInfo },
    data() {
       //这里存放数据
       return {
          tableHeight: 0,
          getRequestData: {},
          returnData: {
             pages: 0, // 总页数
             total: 0, // 总条数
             pageNum: 0, // 当前页数
             list: [],
          },
          buttonList: [],
 
          pageShowData: [],
          formDataList: [],
          selectedDataIndex: 0,
          seTitle: "", //检索
          DialogVisible: false,
          seWidth: "0",
          sField: "",
          seId: 0,
          cmId: 0,
          parentSearchData: {},
          requesUrl: this.$store.getters.getConfig.requestUrl,
          ormId: JSON.parse(sessionStorage.getItem('userInfo')).ormId,
          showAfterSales: false
       };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
       drawerCancel() {
          this.showAfterSales = false
          this.getDataList()
       },
       // 点击穿透字段 传参单号
       toDetail(orderId) {
          if (orderId) {
             // 设置为true 打开穿透组件首页
             var isPenetrate = true;
             // 设置缓存 存入点击单号
             this.resetSetItem("penetrateOrderId", orderId);
             // 与父级跨域通信 传递isPenetrate参数
             window.parent.postMessage(
                {
                   //向窗口发送MessageEvent消息
                   cmd: "returnFormJson",
                   params: { isPenetrate }, //参数
                },
                "*"
             );
          }
       },
       // 检索Id, 索引(表格中), 标识
       openSearch({ sId, index, type, sField }) {
          this.DialogVisible = true;
          this.seId = sId;
          this.sField = sField
          this.parentSearchData[type] = this.getRequestData[type];
       },
       //检索带回数据
       changeInputModel(val) {
          // console.log(val);
 
          if (val != "" || val != undefined) {
             this.DialogVisible = false;
             if (val.cmId) {
                //销售单位
                this.cmId = val.cmId;
                this.getRequestData.cmName = val.cmName;
                this.getRequestData.cmId = val.cmId;
             } else {
                this.paramValue(val)
             }
          }
       },
       // 赋值字段
       paramValue(val) {
          let arr = this.sField.split(',')
          arr.forEach(item => {
             this.getRequestData[item] = val[item]
          })
       },
       getSeWidth(e) {
          // console.log(e);
          this.seWidth = e + "%";
       },
       getWidth(e) {
          // console.log(e);
          this.exWidth = e + "%";
       },
       getSearchName(e) {
          // console.log(e);
          this.seTitle = e;
       },
       isShowData(name, value) {
          // console.log(name)
          switch (name) {
             case "customerList":
                var dataInfo = sessionStorage.getItem("selectCustomerData");
                if (dataInfo) {
                   dataInfo = JSON.parse(dataInfo);
                   this.getRequestData.cmId = dataInfo.cmId;
                   this.getRequestData.cmName = dataInfo.cmName;
                }
 
                break;
 
             default:
                this.getRequestData[name] = value;
          }
       },
 
       async getPageInfo() {
          var pathId = parent.getMenuInfo(this.$route.path);
          let responseData = await this.$http.getJur({ ids: [pathId.jurId] });
          if (responseData.status == 200) {
             this.getButtonList();
             this.pageShowData = responseData.result;
             this.formDataList = [];
             var obj = {}
             if (this.pageShowData.jurHead) {
                obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
             } else {
                obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
             }
             for (const key in obj) {
                this.$set(this.getRequestData, key, obj[key])
             }
             console.log(this.getRequestData);
             this.getDataList();
          } else {
             this.$message({
                message: responseData.message,
                type: "error",
             });
          }
       },
       // 动作集合
       actionSet(actionData) {
          console.log(actionData)
          switch (actionData.actionType) {
             case 4:
                if (!this.returnData.list[this.selectedDataIndex]) {
                   this.$message({
                      message: "请先选择您要操作的数据",
                      type: "error",
                   });
                   return false;
                }
                var dataInfo = JSON.parse(
                   JSON.stringify(this.returnData.list[this.selectedDataIndex])
                );
                this.$refs["processAuditAction"].openBox(0, dataInfo.allotinmId);
                break;
             case 5:
                if (!this.returnData.list[this.selectedDataIndex]) {
                   this.$message({
                      message: "请先选择您要操作的数据",
                      type: "error",
                   });
                   return false;
                }
                var dataInfo = JSON.parse(
                   JSON.stringify(this.returnData.list[this.selectedDataIndex])
                );
                this.$refs["processAuditAction"].openBox(1, dataInfo.allotinmId);
                break;
             case 7:
                this.suBackSuOrderGoBack();
                break;
             case 9:
                this.exportFun()
                break;
             case 10://维护售后信息
 
                if (!this.returnData.list[this.selectedDataIndex]) {
                   this.$message({
                      message: "请先选择您要操作的数据",
                      type: "error",
                   });
                   return false;
                }
 
                this.showAfterSales = true
                this.actionData = {
                   cate: 0,
                   formData: this.formDataList,
                   oldData: this.returnData.list[this.selectedDataIndex],
                   orderId: '',
                   printSouce: '',
                   printJurId: '',
                   type: 'one'
                }
                break;
 
          }
       },
       async exportFun() {
          this.getRequestData.page = 1;
          await this.getDataList()
          if (this.returnData.list.length == 0) {
             this.$message({ type: 'error', message: "暂无数据！" })
             return
          }
          window.location.href = this.requesUrl + '/woApply/exportOrderHisData?ormId='
             + String(this.ormId) + '&cmId=' + this.getRequestData.cmId
             + '&start=' + this.getRequestData.start + '&end=' + this.getRequestData.end
             + '&page=' + this.getRequestData.page + '&rows=' + this.getRequestData.rows + '&origin=' + this.getRequestData.origin
             + '&cmName=' + this.getRequestData.cmName
             + '&woamState=' + this.getRequestData.woamState
             + '&woamId=' + this.getRequestData.woamId || "" + '&woamSalesman=' + this.getRequestData.woamSalesman
       },
       openFormDesign() {
          let pathInfo = parent.getMenuInfo(this.$route.path)
          this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
       },
 
       // 回退
       async suBackSuOrderGoBack() {
          var dataInfo = this.returnData.list[this.selectedDataIndex];
          if (!dataInfo) {
             this.$message({
                message: "请先选中要操作的数据",
                type: "error",
             });
             return false;
          }
          this.$confirm("确定要回退该订单?", "提示", {
             confirmButtonText: "确定",
             cancelButtonText: "取消",
             type: "warning",
          }).then(async () => {
             let responseData = await this.$http.suBackSuOrderGoBack({
                ids: [dataInfo.woamId],
             });
             if (responseData.status == 200) {
                this.$message({
                   type: "success",
                   message: responseData.message,
                });
 
                this.getDataList();
             } else {
                this.$message({
                   message: responseData.message,
                   type: "error",
                });
             }
          }).catch(() => { });
       },
 
       // 数据搜索
       searchData() {
          this.getRequestData.page = 1;
          this.getDataList();
       },
       // 数据翻页
       setDataPageNumber(val) {
          this.getRequestData.page = val;
          //   console.log(val);
          this.getDataList();
       },
 
       // 切换显示条数
       setDataPageSize(val) {
          // console.log(val);
          this.getRequestData.page = 1;
          this.getRequestData.rows = val;
          this.getDataList();
       },
 
       // 获取数据列表
       async getDataList() {
          let responseData = await this.$http.allotinQueryHis(
             this.getRequestData
          );
          if (responseData.status == 200) {
             this.returnData.list = responseData.result.list;
             this.returnData.pages = responseData.result.pages;
             this.returnData.total = responseData.result.total;
             this.returnData.pageNum = responseData.result.pageNum;
             this.selectedDataIndex = 0;
          } else {
             this.$message({
                message: responseData.message,
                type: "error",
             });
          }
       },
 
       // 获取按钮权限
       async getButtonList() {
          this.buttonList = await this.$common.getActionButton()
          
       },
//获取状态
       getIsGsp(str, val) {
          try {
             str && str.replace(/\\/g, "");
             let arr = JSON.parse(str);
             let len = arr.length;
             let newStr = "";
             for (let i = 0; i < len; i++) {
                if (arr[i].key === val) {
                   newStr = arr[i].value;
                   break;
                }
             }
             return newStr;
          } catch (ex) {
             return str;
          }
       },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
       this.$set(
          this.getRequestData,
          "start",
          new Date(new Date().toLocaleDateString()).getTime() -
          31 * 24 * 3600 * 1000
       );
       this.$set(
          this.getRequestData,
          "end",
          new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1
       );
       this.getPageInfo();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
 };
 </script>
 <style scoped>
 .table_content_tag {
    margin-right: 1rem;
 }
 
 .el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
 }
 </style>